export default __webpack_public_path__ + "static/media/566.ed56c030.gif";